import { render, staticRenderFns } from "./DigitalTicketGeneral.vue?vue&type=template&id=2ceacc8d&"
import script from "../../models/analysis/digital-ticket-general.ts?vue&type=script&lang=ts&"
export * from "../../models/analysis/digital-ticket-general.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports